import { PageContent } from '../../content/discover/content';

type GuideSectionProps = PageContent['guide'] & {
  /** Optional. Override section background. Default: "bg-white". */
  sectionClassName?: string;
  /** Optional. Override the inner container sizing/padding. */
  containerClassName?: string;
};

const defaultIntro = "At Peatix, we're passionate about connecting people through shared cultural experiences. We created this comprehensive guide to:";

const GuideSection = ({ points, guideImage, closingText, introParagraph, sectionClassName, headerIcon, bulletStyle, containerClassName }: GuideSectionProps) => {
  const useStandardBullets = bulletStyle === 'standard';
  return (
    <section className={sectionClassName ?? 'bg-white'}>
      <div className={containerClassName ?? "container mx-auto px-4 md:px-8 py-16 w-full max-w-[1280px]"}>
        <div className="flex items-center gap-3 mb-5">
          {headerIcon ? (
            <img src={headerIcon} alt="" className="w-10 h-10 flex-shrink-0" aria-hidden />
          ) : null}
          <h2 className="text-3xl md:text-4xl font-semibold text-gray-900 text-left">Why we created this guide</h2>
        </div>
        <p className="text-left text-gray-600 text-lg mb-12 md:mb-16">
          {introParagraph ?? defaultIntro}
        </p>
        <div className="grid md:grid-cols-2 gap-12 md:gap-16 items-center w-full px-0">
          <div className="space-y-10 md:space-y-12">
            {points.map((point, index) => (
              <div key={index} className="flex items-start gap-4">
                {useStandardBullets ? (
                  <span className="flex-shrink-0 w-2 h-2 rounded-full bg-gray-500 mt-2.5" aria-hidden />
                ) : (
                  <div className="flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center">
                    <img src={point.icon} alt="icon" className="w-12 h-12" />
                  </div>
                )}
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 leading-[30px]">{point.title}</h3>
                  {point.description ? (
                    <p className="text-base font-normal text-gray-600 mt-1 leading-relaxed">{point.description}</p>
                  ) : null}
                </div>
              </div>
            ))}
            <p className="mt-8 text-gray-600 text-base">{closingText}</p>
          </div>
          <div className="relative">
            <img
              src={guideImage}
              alt=""
              className="w-full h-[280px] md:w-[576px] md:h-[480px] rounded-lg shadow-lg object-cover object-center"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default GuideSection; 